import {InstallationId} from "./nominalTypes/InstallationId";
import {TariffId} from "./nominalTypes/TariffId";

export const Ids = {
	Pittsburgh: {
		Id: "110008" as InstallationId,
		Tariffs: {
			VisitorPass:                        "110802" as TariffId,
			ResidentialIndividual:              "110811" as TariffId,
			ResidentialIndividualPlusVisitor:   "110812" as TariffId,
			VisitorRight:                       "110813" as TariffId,
			Business:                           "110814" as TariffId,
			BusinessPlusVisitor:                "110815" as TariffId,
		}
	},
	CoralGables: {
		Id: "110012" as InstallationId,
		Tariffs: {
			Residential:            "111201" as TariffId,
			TemporaryResidential:   "111202" as TariffId,
			Visitor1:               "111203" as TariffId,
			Visitor2:               "111204" as TariffId,
			Visitor3:               "111205" as TariffId,
			Visitor4:               "111206" as TariffId,
		}
	},
	Gloucester: {
		Id: "110002" as InstallationId,
		Tariffs: {
			PassengerVehicle:   "110201" as TariffId,
			Motorcycle:         "110202" as TariffId
		}
	},
	GloucesterLongBeach: {
		Id: "110013" as InstallationId,
		Tariffs: {
			PassengerVehicle:   "111301" as TariffId,
			Motorcycle:         "111302" as TariffId
		}
	},
	Melbourne: {
		Id: "60003" as InstallationId,
		Tariffs: {
			MonthlyNonResident: "60302" as TariffId
		}
	},
	Canmore: {
		Id: "40064" as InstallationId,
		Tariffs: {
			IndividualResidentOneYearRate:  "46301" as TariffId,
			IndividualVisitorPassRate:      "46302" as TariffId,
			IndividualTemporaryWorkerRate:  "46303" as TariffId,
			BusinessRate:                   "46304" as TariffId,
			MonthlyResidentRate:            "46305" as TariffId,
			MonthlyNonResidentRate:         "46306" as TariffId
		}
	}
} as const;
